import { generateUtilityClass } from '@mui/material';

export const numberInputClasses = {
  controlsIntegrated: generateUtilityClass('OriginNumberInput', 'controlsIntegrated'),
  controlsExternal: generateUtilityClass('OriginNumberInput', 'controlsExternal'),
  controlsNone: generateUtilityClass('OriginNumberInput', 'controlsNone'),
};
